import { render, staticRenderFns } from "./Mailtemplateconfiguration.vue?vue&type=template&id=e5e14d0e&scoped=true&"
import script from "./Mailtemplateconfiguration.vue?vue&type=script&lang=js&"
export * from "./Mailtemplateconfiguration.vue?vue&type=script&lang=js&"
import style0 from "./Mailtemplateconfiguration.vue?vue&type=style&index=0&id=e5e14d0e&scoped=scoped&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5e14d0e",
  null
  
)

export default component.exports